// src/components/ModalSeleccionInicialPropiedad.js
import React, { useState, useEffect } from 'react';
import { db } from '../firebase';
import { doc, getDoc } from 'firebase/firestore';
import { FaBuilding, FaHome, FaChevronRight, FaCheckCircle, FaUserCheck } from 'react-icons/fa';
import './ModalSeleccionInicialPropiedad.css';

const ModalSeleccionInicialPropiedad = ({ propiedadesGlobales, onSelectPropiedad, onClose }) => {
    const [fraccionamientoDetails, setFraccionamientoDetails] = useState({});
    const [loadingDetails, setLoadingDetails] = useState(true);

    // Cargar nombres y logos de los fraccionamientos
    useEffect(() => {
        let isMounted = true;
        const fetchDetails = async () => {
            if (!propiedadesGlobales || propiedadesGlobales.length === 0) {
                setLoadingDetails(false);
                return;
            }

            const details = {};
            for (const item of propiedadesGlobales) {
                const fraccId = item.fraccionamientoId;
                try {
                    const snap = await getDoc(doc(db, 'fraccionamientos', fraccId));
                    if (snap.exists()) {
                        const data = snap.data() || {};
                        const configRecibos = data.configuracionRecibos || {};
                        details[fraccId] = {
                            nombre: data.nombre || data.condominioNombre || configRecibos.condominioNombre || `Fraccionamiento ${fraccId}`,
                            logoUrl: configRecibos.logoUrl || data.logoUrl || null,
                            direccion: data.direccion || ''
                        };
                    } else {
                        details[fraccId] = { nombre: `Fraccionamiento ${fraccId}`, logoUrl: null };
                    }
                } catch (e) {
                    console.warn(`ModalSeleccionInicial: Error cargando fracc ${fraccId}`, e);
                    details[fraccId] = { nombre: `Fraccionamiento ${fraccId}`, logoUrl: null };
                }
            }

            if (isMounted) {
                setFraccionamientoDetails(details);
                setLoadingDetails(false);
            }
        };

        fetchDetails();
        return () => { isMounted = false; };
    }, [propiedadesGlobales]);

    const getCasaLabel = (casa) => {
        if (!casa) return 'Vivienda';
        const partes = [];
        if (casa.calle) partes.push(casa.calle);
        if (casa.numero || casa.numeroExterior) partes.push(`No. ${casa.numero || casa.numeroExterior}`);
        if (casa.manzana) partes.push(`Mza ${casa.manzana}`);
        if (casa.lote) partes.push(`Lote ${casa.lote}`);
        return partes.length > 0 ? partes.join(' ') : `Casa ${casa.numero || casa.id}`;
    };

    return (
        <div className="modal-seleccion-propiedad-overlay">
            <div className="modal-seleccion-propiedad-card">
                <div className="modal-residente-header">
                    <div className="modal-residente-pill">
                        <FaHome className="pill-home-icon" />
                        <span>Mis Propiedades | Residente</span>
                    </div>
                    <h2>¡Bienvenido a tu hogar!</h2>
                    <p>Hemos detectado que tienes domicilios registrados. Selecciona a cuál deseas ingresar:</p>
                </div>

                <div className="modal-residente-body">
                    {loadingDetails ? (
                        <div className="modal-seleccion-loading">
                            <div className="spinner-propiedad"></div>
                            <span>Cargando tus fraccionamientos y propiedades...</span>
                        </div>
                    ) : (
                        <div className="fraccionamientos-grid">
                            {propiedadesGlobales.map((group) => {
                                const detail = fraccionamientoDetails[group.fraccionamientoId] || {};
                                const nombreFracc = detail.nombre || `Fraccionamiento ${group.fraccionamientoId}`;
                                const logo = detail.logoUrl;

                                return (
                                    <div key={group.fraccionamientoId} className="fraccionamiento-card-group">
                                        <div className="fraccionamiento-card-header">
                                            {logo ? (
                                                <img src={logo} alt={nombreFracc} className="fraccionamiento-logo-img" />
                                            ) : (
                                                <div className="fraccionamiento-icon-fallback">
                                                    <FaBuilding />
                                                </div>
                                            )}
                                            <div className="fraccionamiento-info">
                                                <h3>{nombreFracc}</h3>
                                                <span>{group.casas.length} {group.casas.length === 1 ? 'propiedad' : 'propiedades'}</span>
                                            </div>
                                        </div>

                                        <div className="casas-list">
                                            {group.casas.map((casa) => (
                                                <button
                                                    key={casa.id}
                                                    type="button"
                                                    className="btn-casa-option"
                                                    onClick={() => onSelectPropiedad(group.fraccionamientoId, casa.id)}
                                                >
                                                    <div className="casa-option-left">
                                                        <FaHome className="icon-casa" />
                                                        <div className="casa-option-text">
                                                            <span className="casa-title">{getCasaLabel(casa)}</span>
                                                            <span className="casa-subtitle">
                                                                {casa.nombre_residente || casa.nombreCompleto ? `Titular: ${casa.nombre_residente || casa.nombreCompleto}` : 'Acceso Directo'}
                                                            </span>
                                                        </div>
                                                    </div>
                                                    <div className="casa-option-right">
                                                        <span className="btn-ingresar-label">Ingresar</span>
                                                        <FaChevronRight />
                                                    </div>
                                                </button>
                                            ))}
                                        </div>
                                    </div>
                                );
                            })}
                        </div>
                    )}
                </div>

                {onClose && (
                    <div className="modal-residente-footer">
                        <button type="button" className="btn-cancelar-modal" onClick={onClose}>
                            Continuar con selección previa
                        </button>
                    </div>
                )}
            </div>
        </div>
    );
};

export default ModalSeleccionInicialPropiedad;
